import Component from "flarum/common/Component";
import Button from "flarum/common/components/Button";
import Dropdown from 'flarum/common/components/Dropdown';
import LogInModal from "flarum/components/LogInModal";
import AdvPostEditor from "./AdvPostEditor";
import AdvCommentEditor from "./AdvCommentEditor";
import FlagAdvcommentModal from "./FlagAdvcommentModal";
import username from "flarum/common/helpers/username";
// import userOnline from "flarum/common/helpers/userOnline";
import avatar from "flarum/common/helpers/avatar";
import humanTime from "flarum/common/helpers/humanTime";
import Stream from "flarum/common/utils/Stream";
import Link from "flarum/common/components/Link";
import replaceContent from "../helpers/replaceContent";
import isFunction from "../helpers/isFunction";
import VotesCommentsModal from "./VotesCommentsModal";
import app from 'flarum/forum/app';

const getUserById = (userId) => {
  if (!userId) {
    return app.session.user;
  }

  let user = app.store.getById("users", userId);

  if (!user) {
    app.store.find("users", userId).then((r) => {
      user = r;
    });
  };
  return user;
};

function flagReason(flag) {
    if (flag.type() === 'user') {
      const user = flag.user();
      const reason = flag.reason() ? app.translator.trans(`flarum-flags.forum.flag_post.reason_${flag.reason()}_label`) : null;
      const detail = flag.reasonDetail();
      const time = humanTime(flag.createdAt());

      return [
        app.translator.trans(reason ? 'flarum-flags.forum.post.flagged_by_with_reason_text' : 'flarum-flags.forum.post.flagged_by_text', {
          time,
          user,
          reason,
        }),
        !!detail && <span className="Post-flagged-detail">{detail}</span>,
      ];
    }
  }

class VoteCounterComponent extends Component {
  view() {
    return <label class="Post-points">{this.attrs.counter}</label>;
  }
}



export default class AdvPostComments extends Component {
  oninit(vnode) {
    super.oninit(vnode);

    this.postId = this.attrs.postId;
    this.post = this.attrs.post;
    this.discussionId = this.post.data.relationships.discussion.data.id;
    // console.log(this.post.advcomments());

    this.postComments = Stream(this.post.advcomments());
    this.addCommentText = app.translator.trans(
      "tolyod-advdiscus.forum.post.add.comment.add_button"
    );

    // this.loading = {};
    this.voteLoading = Stream(false);

    this.postFlags = this.post.flags().length > 0 ?
      this.post.flags().reduce((acc, flag) => {
        if (!!flag.advcommentId()) {
          acc = [...acc, [flag.advcommentId(), flag]];
        }
        return acc;
      }, [])
      : [];
    }

  addCommentData(postId, discussionId, data) {
    this.newAdvcommentAction(postId, discussionId, data).catch(() => {});
  }

  newAdvcommentAction(postId, discussionId, data) {
    const curPost = app.store.getById("posts", postId);
    const editorAttrs = {
      user: app.session.user,
      discussion: discussionId,
      post: curPost,
      postComments: this.postComments
    };

    return new Promise((resolve, reject) => {
      if (app.session.user) {
        app.composer.load(AdvPostEditor, editorAttrs);
        app.composer.show();

        return resolve(app.composer);
      } else {
        app.modal.show(LogInModal);

        return reject();
      }
    });
  }

  editComment(advcomment, ctx) {
    // const curPost = app.store.getById("posts", postId);

    return new Promise((resolve, reject) => {
      if (app.session.user) {
        app.composer.load(AdvCommentEditor, {
          user: app.session.user,
          comment: advcomment,
          ctx: ctx,
        });
        app.composer.show();

        return resolve(app.composer);
      } else {
        app.modal.show(LogInModal);

        return reject();
      }
    });
  }

  vote(advcomment, value, load) {
    const isUpVote = value > 0;
    const isDownVote = value < 0;
    advcomment
      .save({vote: { isUpVote, isDownVote, value }})
      .then(() => m.redraw());
  }

  deleteComment(advcomment, ctx) {

    const curPostNumber = ctx.post.number();
    const curAdvcomments = ctx.postComments();
    const curAdvcommentId = advcomment.id();

    advcomment.delete()
      .then(() => {
        const newAdvcomments = curAdvcomments.filter(e => curAdvcommentId !== e.id());
        ctx.postComments(newAdvcomments);
        app.current.get('stream').goToNumber(curPostNumber);
/*         app.current.get('stream').update(); */
/*         m.redraw(); */
      });
  }



  view(vnode) {
    let { options = {}, postId, ctx, ...attrs } = vnode.attrs;
    const postComments = isFunction(this.postComments)
      ? this.postComments()
      : [];
    // const postComments = this.postComments();
    const postCommentsCount = postComments.length;

    // For some reason, m.route.Link does not like vnode.text, so if present, we
    // need to convert it to text vnodes and store it in children.
    // const children = vnode.children || { tag: '#', children: vnode.text };

    attrs.options = options;
    const moderatorGroup = "4";
    const adminGroup = "1";
    const isCurUserModerator = app.session.user
      .groups()
      .map((g) => g.id())
      .filter(n => [moderatorGroup, adminGroup].includes(n)).length > 0;
    const curUserId = app.session.user.id();

    const commentsCountText =
      postCommentsCount > 0
        ? app.translator.trans(
            "tolyod-advdiscus.forum.post.add.comment.button_comments",
            { count: postCommentsCount }
          )
        : app.translator.trans(
            "tolyod-advdiscus.forum.post.add.comment.button_comment"
          );

    return (
      <div>
        <Button
          className="Button Button--link"
          onclick={() =>
            this.addCommentData(this.postId, this.discussionId, "")
          }
          icon="fas fa-comments"
        >
          {commentsCountText}
        </Button>
        <ul className="tolyod-advdiscus-comments">
          {postComments.map((advcomment, i) => {
            const user = advcomment.user() === false ? getUserById(advcomment.user_id()) : advcomment.user();

            const isOwner = curUserId == advcomment.user_id();
            const canDelete = isOwner || isCurUserModerator;
            const commentContent = isFunction(advcomment.contentHtml) ? advcomment.contentHtml() : advcomment.contentHtml;
            const isFlagged = this.postFlags.some(e => e[0] == advcomment.id());
            const liClassName = `AdvCommentsLiElem ${isFlagged ? "flagged" : ""}`;
            const [_, curFlag] = isFlagged ? this.postFlags.find(e => e[0] == advcomment.id()) : ['', ''];
            // if (isFlagged) {
            //   // console.log( curFlag.reason(), curFlag.reasonDetail(), curFlag.user());
            // }
            return (
              <li key={i} className={liClassName}>
                {isFlagged ? <div className="commentFlagMessage">{flagReason(curFlag)}</div>: ""}
                <div className="PostUser AdvCommentsPostUser">
                  <h3 data-user-id={user.id()}>
                    {user ? (
                      <Link href={app.route.user(user)}>
                        {avatar(user)} {username(user)}
                      </Link>
                    ) : (
                      username(user)
                    )}
                  </h3>
                </div>
                <div
                  className="AdvCommentText"
                  data-key={i}
                  data-advcomment-id={advcomment.id()}
                >
                  {m.trust(replaceContent(commentContent))}
                </div>
                <span className="AdvCommentDate">
                  { humanTime(advcomment.created_at())}
                </span>
                <div
                  style={{
                    position: "relative",
                    height: "35px",
                    float: "right",
                    width: "140px",
                  }}
                >
                  <span
                    class="CommentPost-votes false"
                    style={{
                      position: "absolute",
                      right: "-7px",
                      bottom: "16px",
                    }}
                  >
                    <button
                      class="Post-vote Post-upvote hasIcon"
                      type="button"
                      title=""
                      style="color: rgb(77, 105, 142);"
                      onclick={() => this.vote(advcomment, 1, this.voteLoading)}
                    >
                      <i class="icon fas fa-thumbs-up Button-icon"></i>
                      <span class="Button-label"></span>
                    </button>
                    <VoteCounterComponent
                      counter={advcomment.votesSum() ?? null}
                    />
                    <button
                      class="Post-vote Post-downvote hasIcon"
                      type="button"
                      title=""
                      style=""
                      onclick={() =>
                        this.vote(advcomment, -1, this.voteLoading)
                      }
                    >
                      <i class="icon fas fa-thumbs-down Button-icon"></i>
                      <span class="Button-label"></span>
                    </button>
                    { canDelete ? (
                      <Dropdown
                        className="Comments-controls"
                        buttonClassName="Button Button--icon Button--flat"
                        menuClassName="Dropdown-menu--right"
                        icon="fas fa-ellipsis-h"
                        onshow={() => this.$('.Post-controls').addClass('open')}
                        onhide={() => this.$('.Post-controls').removeClass('open')}
                        accessibleToggleLabel={app.translator.trans('core.forum.post_controls.toggle_dropdown_accessible_label')}
                      >
                        <Button
                          icon="fas fa-flag"
                          onclick={() => app.modal.show(FlagAdvcommentModal, { advcomment })}
                          data-id={advcomment.id()}
                        >{app.translator.trans('flarum-flags.forum.post_controls.flag_button')}</Button>

                        <Button
                          icon="fas fa-pencil-alt"
                          onclick={() => this.editComment(advcomment, this)}
                          data-id={advcomment.id()}
                        >{app.translator.trans('tolyod-advdiscus.forum.comments_contorls.buttons.edit')}</Button>

                        <Button
                          icon="fas fa-trash"
                          onclick={() => this.deleteComment(advcomment, this)}
                          data-id={advcomment.id()}
                        >{app.translator.trans('tolyod-advdiscus.forum.comments_contorls.buttons.delete')}</Button>
                        <Button
                          icon="fas fa-thumbs-up"
                          onclick={() => app.modal.show(VotesCommentsModal, { advcomment })}
                          data-id={advcomment.id()}
                        >{app.translator.trans('fof-gamification.forum.mod_item')}</Button>

                      </Dropdown>
                    ) : (
                        <Dropdown
                          className="Comments-controls"
                          buttonClassName="Button Button--icon Button--flat"
                          menuClassName="Dropdown-menu--right"
                          icon="fas fa-ellipsis-h"
                          onshow={() => this.$('.Post-controls').addClass('open')}
                          onhide={() => this.$('.Post-controls').removeClass('open')}
                          accessibleToggleLabel={app.translator.trans('core.forum.post_controls.toggle_dropdown_accessible_label')}
                        >
                        <Button
                          icon="fas fa-flag"
                          onclick={() => app.modal.show(FlagAdvcommentModal, { advcomment })}
                          data-id={advcomment.id()}
                        >{app.translator.trans('flarum-flags.forum.post_controls.flag_button')}</Button>
                          <Button
                            icon="fas fa-thumbs-up"
                            onclick={() => app.modal.show(VotesCommentsModal, { advcomment })}
                            data-id={advcomment.id()}
                          >{app.translator.trans('fof-gamification.forum.mod_item')}</Button>
                        </Dropdown>
                      )
                    }
                  </span>
                </div>
              </li>
            );
          })}
          {postCommentsCount > 0 ? (
            <li className="AdvCommentsLiElem AddCommentButton">
              <Button
                className="Button Button--link advCommentsAddMyCommentButton"
                icon="fas fa-paper-plane"
                onclick={() =>
                  this.addCommentData(this.postId, this.discussionId, "")
                }
              >
                {this.addCommentText}
              </Button>
            </li>
          ) : (
            ""
          )}
        </ul>
      </div>
    );
  }
}
